import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ReservationForm from "./components/ReservationForm";
import InfoReserva from "./pages/InfoReserva";
import ReservaCliente from "./pages/ReservaCliente";
import ReservaClientePorPais from "./pages/ReservaClientePorPais";
import Reserva from "./pages/Reserva";
import Anamnesis from "./pages/Anamnesis";
import GoogleMapsProvider from "./context/GoogleMapsProvides";
import { FormProvider } from "./context/FormContext";
import "@fontsource/montserrat";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/400-italic.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./App.css";
import "./styles/LuxoticaLandingStyles.css";
import Reprogramar from "./pages/Reprogramar";
import GoogleTagManager from "./components/GoogleTagManager";
import MetaEtiquetas from "./components/MetaEtiquetas";

// Componente para debug de rutas
// const RouteDebugger = () => {
//   const location = useLocation();
//   useEffect(() => {
//     console.log("🛠️ Navegando a:", location.pathname);
//   }, [location]);
//   return null;
// };

const App = () => {
  return (
    <div className="App">
      <MetaEtiquetas />
      <GoogleTagManager />
      <GoogleMapsProvider>
        <FormProvider>
          <BrowserRouter>
            {/* <RouteDebugger /> */}
            <Routes>
              {/* ✅ Ruta principal */}
              <Route path="/" element={<Reserva />} />
              <Route path="/reserva" element={<Reserva />} />

              {/* ✅ Ruta dinámica correctamente ubicada */}
              <Route path="/:cadena-:pais" element={<Reserva />} />

              {/* ✅ Rutas en duro */}
              <Route path="/gmo-cl" element={<Reserva />} />
              <Route path="/opv-cl" element={<Reserva />} />
              <Route path="/eco-cl" element={<Reserva />} />



              <Route path="/gmo-co" element={<Reserva />} />
              <Route path="/gmo-pe" element={<Reserva />} />
              <Route path="/gmo-ec" element={<Reserva />} />
              {/* ✅ Otras rutas */}
              <Route path="/reservaFormulario" element={<ReservationForm />} />
              <Route path="/inforeserva" element={<InfoReserva />} />
              <Route path="/reservacliente" element={<ReservaCliente />} />
              <Route path="/reservaclienteporpais" element={<ReservaClientePorPais />} />
              <Route path="/anamnesis" element={<Anamnesis />} />
              <Route path="/reagendamiento" element={<Reprogramar />} />

              {/* ✅ Ruta de fallback para rutas incorrectas */}
              <Route path="*" element={<h1>❌ Página no encontrada</h1>} />
            </Routes>
          </BrowserRouter>
        </FormProvider>
      </GoogleMapsProvider>
    </div>
  );
};

export default App;
